export function formatCurrency(amount) {
  return new Intl.NumberFormat("en-ZA", {
    style: "currency",
    currency: "ZAR",
    minimumFractionDigits: 2,
  })
    .format(amount)
    .replace("ZAR", "R"); // Replace default symbol with "R" for local style
}
